var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('EditorHeader',{staticClass:"pb-4",attrs:{"title":_vm.$ct(_vm.$route.params.id ? "edit": "create")}}),_c('ScaleEditor',{attrs:{"scale":_vm.scale},on:{"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }